function normalize(value: string | undefined) {
  const trimmed = value?.trim();
  if (!trimmed || trimmed.startsWith("$")) {
    return "";
  }
  return trimmed.toLowerCase();
}

const rawPublicVercelEnv = normalize(process.env.NEXT_PUBLIC_VERCEL_ENV);
const rawVercelEnv = normalize(process.env.VERCEL_ENV);
const rawNodeEnv = normalize(process.env.NODE_ENV);

const resolvedEnv = rawPublicVercelEnv || rawVercelEnv || rawNodeEnv;

export const sentryEnvironment =
  resolvedEnv === "production" || resolvedEnv === "vercel-production"
    ? "production"
    : resolvedEnv === "preview" || resolvedEnv === "vercel-preview"
      ? "preview"
      : "development";
